const reports = {
  reports: {
    balanceReport: 'Balance',
    lastDayPlayed: 'Last Day Played',
    lifetimeWL: 'Lifetime W/L',
    reportTypeLabel: 'Report Type',
    debitTime: 'Debit Time',
    creditTime: 'Credit Time',
    bonusMoneyBet: 'Bet Amount',
    bonusMoneyWin: 'Win Amount',
    bonusBalanceAfter: 'Balance After',
    bet: 'Bet',
    win: 'Win',
    rounds: 'Rounds',
    rtp: 'RTP',
    gameWin: 'Game Win',
    byBrand: 'Brand Name',
    addGameName: 'Add Game Name',
    providerRoundId: 'Provider Round Id',
    providerTransactionId: 'Provider Transaction Id',
    internalTransactionId: 'Internal Transaction Id',
    transactionTypePayment: {
      REAL_MONEY: 'Real Money',
      BONUS_MONEY: 'Bonus Money',
    },
    reportsTypeOptions: {
      BY_ROUNDS: 'By Rounds',
      BY_GAME: 'By Game',
      BY_CATEGORY: 'By Category',
      BY_PROVIDER: 'By Provider',
      BY_PLAYER_ID: 'By Player ID',
      BY_BRAND: 'By Brand',
    },
  },
}

export default reports
